import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import CartDrawer from "@/components/CartDrawer";
import WelcomePopup from "@/components/WelcomePopup";
import CartRecovery from "@/components/CartRecovery";
import Home from "@/pages/Home";
import Catalog from "@/pages/Catalog";
import ProductDetail from "@/pages/ProductDetail";
import CartPage from "@/pages/CartPage";
import PaymentSuccess from "@/pages/PaymentSuccess";
import Auth from "@/pages/Auth";
import Ambassador from "@/pages/Ambassador";
import Account from "@/pages/Account";
import Admin from "@/pages/Admin";
import Legal from "@/pages/Legal";
import { initPixels, trackPageView } from "@/lib/pixels";

function PixelPageViews() {
  const location = useLocation();
  useEffect(() => { trackPageView(location.pathname); }, [location.pathname]);
  return null;
}

function App() {
  useEffect(() => { initPixels(); }, []);

  return (
    <div className="App">
      <AuthProvider>
        <CartProvider>
          <BrowserRouter>
            <PixelPageViews />
            <Header />
            <CartDrawer />
            <WelcomePopup />
            <CartRecovery />
            <main className="min-h-[60vh]">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/tienda" element={<Catalog />} />
                <Route path="/producto/:id" element={<ProductDetail />} />
                <Route path="/carrito" element={<CartPage />} />
                <Route path="/pago-exitoso" element={<PaymentSuccess />} />
                <Route path="/entrar" element={<Auth />} />
                <Route path="/embajadores" element={<Ambassador />} />
                <Route path="/cuenta" element={<Account />} />
                <Route path="/admin" element={<Admin />} />
                <Route path="/legal/:doc" element={<Legal />} />
              </Routes>
            </main>
            <Footer />
          </BrowserRouter>
          <Toaster position="top-center" richColors />
        </CartProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
